"use client";

import { useEffect, useState } from "react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Button } from "@/components/ui/button";
import { Menu, X } from "lucide-react";
function HeaderMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  if (loading) {
    return <div data-section-id="15994" className="hidden md:flex gap-1">
        <div className="h-9 w-16 bg-muted/10 animate-pulse rounded-sm" />
        <div className="h-9 w-16 bg-muted/10 animate-pulse rounded-sm" />
        <div className="h-9 w-16 bg-muted/10 animate-pulse rounded-sm" />
      </div>;
  }
  return <>
      {}
      <NavigationMenu viewport={false} className="hidden md:flex">
        <NavigationMenuList>
          {menuItems.map(item => <NavigationMenuItem key={item.id} data-index={item.id}>
              <NavigationMenuLink asChild>
                <Link to={item.href || "#"} className="text-foreground hover:text-white transition-all duration-300 px-4 py-2 text-sm font-medium font-sans tracking-normal hover:scale-[1.02] animate-in fade-in slide-in-from-top-1 duration-500">
                  {item.label}
                </Link>
              </NavigationMenuLink>
            </NavigationMenuItem>)}
        </NavigationMenuList>
      </NavigationMenu>

      {}
      <Button variant="ghost" size="icon" className="md:hidden text-foreground hover:bg-accent/10" onClick={() => setMobileMenuOpen(!mobileMenuOpen)}>
        {mobileMenuOpen ? <X className="size-5" /> : <Menu className="size-5" />}
      </Button>

      {}
      {mobileMenuOpen && <div className="absolute top-full left-0 right-0 bg-background/98 backdrop-blur-xl border-b border-border/20 md:hidden shadow-2xl">
          <nav className="flex flex-col py-4 px-4 gap-2">
            {menuItems.map(item => <Link key={item.id} data-index={item.id} to={item.href || "#"} className="text-foreground hover:text-white transition-colors px-4 py-2 text-sm font-medium font-sans rounded-lg hover:bg-accent/5 hover:scale-[1.02] animate-in fade-in slide-in-from-left-2 duration-300" onClick={() => setMobileMenuOpen(false)}>
                {item.label}
              </Link>)}
          </nav>
        </div>}
    </>;
}
export default function EnTêteDeNavigation() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  useEffect(() => {
    const handleAnchorClick = (e: MouseEvent) => {
      const target = e.target as HTMLElement;
      const anchor = target.closest("a[href]") as HTMLAnchorElement | null;
      if (anchor) {
        const href = anchor.getAttribute("href");
        if (!href) return;
        if (href === "/#") {
          e.preventDefault();
          window.scrollTo({
            top: 0,
            behavior: "smooth"
          });
          return;
        }
        let hash = "";
        if (href.startsWith("#")) {
          hash = href;
        } else if (href.startsWith("/") && href.includes("#")) {
          const [path, hashPart] = href.split("#");
          if (hashPart === "") {
            e.preventDefault();
            window.scrollTo({
              top: 0,
              behavior: "smooth"
            });
            return;
          }
          if (path === "/" || path === window.location.pathname) {
            hash = "#" + hashPart;
          }
        }
        if (hash && hash !== "#") {
          const element = document.querySelector(hash);
          if (element) {
            e.preventDefault();
            element.scrollIntoView({
              behavior: "smooth",
              block: "start"
            });
          }
        }
      }
    };
    document.addEventListener("click", handleAnchorClick);
    return () => document.removeEventListener("click", handleAnchorClick);
  }, []);
  {}
  return <section id="en-tête-de-navigation" className="dark bg-background text-foreground">
      <header className={`sticky top-0 z-50 w-full transition-all duration-500 ${scrolled ? "bg-background/80 backdrop-blur-md border-b border-border/30 shadow-lg" : "bg-background border-b border-border/10"}`}>
        <div className="container mx-auto px-4 lg:px-8">
          <div className="flex items-center justify-between h-16">
            {}
            <Link to="#" className="flex items-center gap-2">
              <img src="https://freelancecomevent.com/wp-content/uploads/2026/04/FCE_Logo-4-Horizontal-copie-1-scaled.png" alt="Freelance Com & Event" className="h-16 brightness-110" />
            </Link>

            {}
            <MenuProvider menu_id="66" className="flex-1 flex justify-center">
              <HeaderMenuConsumer />
            </MenuProvider>

            {}
            <div className="hidden md:flex items-center gap-3">
              <Link to="#">
                
              </Link>
              <Link to="#">
                <Button className="bg-primary text-primary-foreground hover:bg-primary/90 rounded-lg px-6 font-sans font-medium transition-all shadow-md hover:shadow-primary/20">
                  Démarrer un projet
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </header>
    </section>;
}